import FancyBoxSvg281x765 from './FancyBoxSvg281x765';

export default FancyBoxSvg281x765;
export { FancyBoxSvg281x765 };
